import { WidgetClosingTrigger } from '@wix/wix-chatbot-common/bi';

import { biCloseWidget } from '../../bi';
import { dispatch } from '../../store';

export const collapseWidget = (closingTrigger: WidgetClosingTrigger): void => {
  dispatch('widget/expanded', false);
  biCloseWidget(closingTrigger);
};
